import { ActionTypes } from '../actions/event_index';

const initialState = {};

// Single source of truth for the per-event entry shape and its defaults,
// keyed state[eventId]. Every case that writes an entry must spread this
// (via getEventState) so a partial entry can never be created.
function createEventState() {
  return {
    loading: false,
    error: null,
    showFullLeaderboard: true,
    favorites: [],
    etag: null,
    data: {},
  };
}

function getEventState(state, eventId) {
  return state[eventId] ?? createEventState();
}

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_RESULT_SCOPE_REQUEST: {
      const { eventId } = action.payload;
      const prevEvent = getEventState(state, eventId);

      return {
        ...state,
        [eventId]: { ...prevEvent, loading: true },
      };
    }

    case ActionTypes.FETCH_RESULT_SCOPE_SUCCESS: {
      const { eventId, data, etag } = action.payload;
      const prevEvent = getEventState(state, eventId);

      return {
        ...state,
        [eventId]: {
          ...prevEvent,
          loading: false,
          data,
          etag: etag ?? prevEvent.etag,
        },
      };
    }

    case ActionTypes.FETCH_RESULT_SCOPE_FAILURE: {
      const { eventId, error } = action.payload;
      const prevEvent = getEventState(state, eventId);

      return {
        ...state,
        [eventId]: { ...prevEvent, loading: false, error },
      };
    }

    case ActionTypes.REMOVE_RESULT_SCOPE: {
      const { eventId } = action.payload;
      const { [eventId]: _removed, ...restEvents } = state;
      return restEvents;
    }

    case ActionTypes.TOGGLE_FAVORITE: {
      const { eventId, favorites } = action.payload;
      const prevEvent = getEventState(state, eventId);
      const showFullLeaderboard = favorites.length === 0 ? true : prevEvent.showFullLeaderboard;

      return {
        ...state,
        [eventId]: { ...prevEvent, showFullLeaderboard, favorites },
      };
    }

    case ActionTypes.RETRIEVE_FAVORITES: {
      const { eventId, cachedFavorites, favoritesOnly } = action.payload;

      return {
        ...state,
        [eventId]: {
          ...getEventState(state, eventId),
          showFullLeaderboard: !favoritesOnly,
          favorites: cachedFavorites,
        },
      };
    }

    case ActionTypes.TOGGLE_FULL_LEADERBOARD: {
      const { eventId } = action.payload;
      const prevEvent = getEventState(state, eventId);
      return {
        ...state,
        [eventId]: { ...prevEvent, showFullLeaderboard: !prevEvent.showFullLeaderboard },
      };
    }

    case ActionTypes.CLEAR_EVENT_SLICE: {
      const { eventIdToKeep } = action.payload;
      return { [eventIdToKeep]: state[eventIdToKeep] };
    }

    case ActionTypes.FULL_CLEAR_EVENT_SLICE:
      return {};

    default:
      return state;
  }
}
